export default {
    top_menu: [
        {name:'Το κύριο πράγμα',    id:0},
        {name:'Βιομηχανία του θεάματος', id:1},
        {name:'Μαγείρεμα',  id:2},
        {name:'Πολιτική',   id:3},
        {name:'+18',  id:4},
        {name:'Κοινωνία',   id:5},
        {name:'Υγεία',   id:6},
    ],
    read_other: 'Διαβάστε περισσότερα',
    read_more:  'Περισσότερες λεπτομέρειες',
    not_found:  'Δεν βρέθηκε τίποτα',
    read_also:  'Διαβάστε επίσης',
    copy_rights: 'Copyright © 2019 «mixer-novostei.ru». Ολα τα δικαιώματα διατηρούνται.',
    subscribe: 'Εγγραφείτε στο',

    thank_order: 'ΕΥΧΑΡΙΣΤΟΥΜΕ ΓΙΑ ΤΗΝ ΠΑΡΑΓΓΕΛΙΑ ΣΑΣ',
    specialist_contact: 'Ο ειδικός μας θα επικοινωνήσει σύντομα μαζί σας, περιμένετε την κλήση μας.',
    attention: 'Εκπτώσεις από συνεργάτες:',
    hurry: 'Βιαστείτε, ο χρόνος ενεργοποίησης της έκπτωσης είναι περιορισμένος! Έχετε μόνο <span id="time" class="time">30:00</span> λεπτά για να επιλέξετε ένα από αυτά τα μοναδικά προϊόντα:',

    hour_ago1: "Ώρα πριν",
    hour_ago2: "ώρες πριν",
    hour_ago3: "ώρες πριν",
    new_publications: "Νέες δημοσιεύσεις",
    read: "Ανάγνωση",
    today_at: "Σήμερα στις",
    author_names: ['Έλενα Παπαρίζου','Άννα Βίσση','Σάκης Ρουβάσα'],
    main_news: "Κύρια νέα",
    leave_already: "Φεύγετε ήδη; Περιμένετε, έχουμε ενημερώσει τα νέα για εσάς",
    already_shared: "μοιράστηκε ήδη"

}